import type { StateCreator } from 'zustand'

import type { OmniboxState } from '../appSlice/deriveModeTransition'
import type { AppSlice } from '../appSlice'
import type { CapabilitySlice } from '../capabilitySlice'
import type { ChannelSlice } from '../channelSlice'
import type { DirtySlice } from '../dirtySlice'
import type { EditorSlice } from '../editorSlice'
import type { PostSlice } from '../postSlice/postSlice'
import type { SaveErrorsSlice } from '../saveErrorsSlice'

export interface ModeState {
  /**
   * Mirrors `AppStore.getIsOmniboxEnabled()` — a value copy only, Flux stays
   * the decision-maker. Written solely by `installFluxToModeMirror`; not yet
   * read by any production consumer.
   */
  isOmniboxEnabled: OmniboxState
}

export interface ModeActions {
  /** Written only by `installFluxToModeMirror`. */
  setIsOmniboxEnabled: (isOmniboxEnabled: OmniboxState) => void
}

export type ModeSlice = ModeState & ModeActions

export const createModeSlice: StateCreator<
  AppSlice &
    CapabilitySlice &
    ChannelSlice &
    DirtySlice &
    EditorSlice &
    PostSlice &
    SaveErrorsSlice &
    ModeSlice,
  [['zustand/devtools', never], ['zustand/immer', never]],
  [],
  ModeSlice
> = (set) => ({
  isOmniboxEnabled: null,

  setIsOmniboxEnabled: (isOmniboxEnabled): void =>
    set(
      (state) => {
        state.isOmniboxEnabled = isOmniboxEnabled
      },
      undefined,
      'modeSlice:setIsOmniboxEnabled',
    ),
})
